import { AnalyticsStoreProvider } from '../contexts';

import TopLevelStats from '../top_level_stats/TopLevelStats';
import TopPages from '../top_pages/TopPages';
import TopSources from '../top_sources/TopSources';
import RecentApplications from '../recent_applications/RecentApplications';
import RecentTraffic from '../recent_traffic/RecentTraffic';

import DateRangeComparatorInput from '../inputs/DateRangeComparatorInput';

export default function AnalyticsDashboard({ endpoints }) {
  const {
    job_applications_count_api_v1_cms_analytics_path,
    jobs_posted_count_api_v1_cms_analytics_path,
    new_visitors_and_average_time_on_site_api_v1_cms_analytics_path,
    recent_traffic_api_v1_cms_analytics_path,
    admin_job_applications_path,
    admin_job_application_with_id_path,
    recent_applications_list_api_v1_cms_analytics_path,
    recent_applications_traffic_api_v1_cms_analytics_path,
    admin_analytics_report_pages_path,
    admin_analytics_report_sources_path,
    top_pages_api_v1_cms_analytics_path,
    top_sources_api_v1_cms_analytics_path,
  } = endpoints;

  return (
    <AnalyticsStoreProvider>
      <div id="analytics-landing">
        <div className="row pb-3">
          <div className="col">
            <div className="d-flex justify-content-end">
              <div className="d-flex flex-column gap-3 align-items-end">
                <div className="d-flex gap-3 align-items-center">
                  <DateRangeComparatorInput />
                </div>
              </div>
            </div>
          </div>
        </div>

        <TopLevelStats
          endpoints={{
            job_applications_count_api_v1_cms_analytics_path,
            jobs_posted_count_api_v1_cms_analytics_path,
            new_visitors_and_average_time_on_site_api_v1_cms_analytics_path,
          }}
        />

        <div className="row">
          <div className="col">
            <RecentTraffic endpoints={{ recent_traffic_api_v1_cms_analytics_path }} />
          </div>
        </div>

        <div className="row">
          <div className="col">
            <RecentApplications
              endpoints={{
                admin_job_applications_path,
                admin_job_application_with_id_path,
                recent_applications_list_api_v1_cms_analytics_path,
                recent_applications_traffic_api_v1_cms_analytics_path,
              }}
            />
          </div>

          <div className="col">
            <div className="row">
              <div className="col">
                <TopPages endpoints={{ top_pages_api_v1_cms_analytics_path, admin_analytics_report_pages_path }} />
              </div>
            </div>

            <div className="row">
              <div className="col">
                <TopSources endpoints={{ top_sources_api_v1_cms_analytics_path, admin_analytics_report_sources_path }} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </AnalyticsStoreProvider>
  );
}
